module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workflow-step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v(_vm._s(_vm.stepNumber))]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h3', {
    staticClass: "step-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "step-description"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f7fb5ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pricing-costs/WorkflowStep.vue
// module id = 724
// module chunks = 2